import React from "react";
import {
  Alert,
  AlertTitle,
  IconButton,
  Snackbar,
  Typography,
} from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CloseIcon from "@mui/icons-material/Close";
import { useTheme } from "@mui/material/styles";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import WarningAmberOutlinedIcon from "@mui/icons-material/WarningAmberOutlined";
import { useStyles } from "../../assets/styles/Theme";

const SystemAlert = ({ open, type, message, onClose }) => {
  const theme = useTheme();
  const styles = useStyles(theme);

  const getIcon = () => {
    switch (type) {
      case "success":
        return <CheckCircleIcon sx={{ color: theme.palette.system.success }} />;
      case "error":
        return <InfoOutlinedIcon sx={{ color: theme.palette.system.error }} />;
      case "warning":
        return (
          <WarningAmberOutlinedIcon
            sx={{ color: theme.palette.system.pending }}
          />
        );
      case "info":
        return <InfoOutlinedIcon sx={{ color: theme.palette.system.submit }} />;
      default:
        return <CheckCircleIcon />;
    }
  };

  const getAlertStyles = () => {
    switch (type) {
      case "success":
        return {
          backgroundColor: theme.palette.system.successTertiary,
          border: `1px solid ${theme.palette.system.success}`,
          color: theme.palette.system.success,
        };
      case "error":
        return {
          backgroundColor: theme.palette.system.errorTertiary,
          border: `1px solid ${theme.palette.system.error}`,
          color: theme.palette.system.error,
        };
      case "warning":
        return {
          backgroundColor: theme.palette.system.pendingTertiary,
          border: `1px solid ${theme.palette.system.pending}`,
          color: theme.palette.system.pending,
        };
      case "info":
        return {
          backgroundColor: theme.palette.system.submitTertiary,
          border: `1px solid ${theme.palette.system.submit}`,
          color: theme.palette.system.submit,
        };
      default:
        return {};
    }
  };

  return (
    <Snackbar
      open={open}
      anchorOrigin={{ vertical: "top", horizontal: "right" }}
      autoHideDuration={2000}
      onClose={onClose}
    >
      <Alert
        severity={type}
        icon={getIcon()}
        sx={{
          ...getAlertStyles(),
          fontWeight: 500,
          boxShadow: "0px 2px 10px rgba(0,0,0,0.1)",
          minWidth: 300,
          display: "flex",
          alignItems: "center",
        }}
        action={
          <IconButton
            aria-label="close"
            color="inherit"
            size="small"
            onClick={onClose}
          >
            <CloseIcon fontSize="inherit" />
          </IconButton>
        }
      >
        {/* <AlertTitle>{type.charAt(0).toUpperCase() + type.slice(1)}</AlertTitle> */}
        <Typography variant="body_xs">{message}</Typography>
      </Alert>
    </Snackbar>
  );
};

export default SystemAlert;
